import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { poolCouponRowInput } from './input.row.js';

const selectAnswersPoolCouponTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("PoolCoupon"),
  header: z.string(),
  columns: z.array(z.string()),
  rows: z.array(poolCouponRowInput.schema)
}).transform(({
  rows,
  columns,
  header,
  ...rest
}) => ({
  ...rest,
  tableHeading: header,
  tableColumnHeadings: columns,
  content: rows.map((it, index) => poolCouponRowInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index
  }))
}));

export { selectAnswersPoolCouponTaskSchema };
//# sourceMappingURL=_schema.js.map
